import state from './hvaccontroller.state'
import mutations from './hvaccontroller.mutations'
import actions from './hvaccontroller.actions'

export default {
  state,
  mutations,
  actions
}
